import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange } from "../../../library-js/dom-tools/EventListeners";
import { isPrimitive } from "../../../library-js/tools/TypeUtilities";

export class ComputationForm
{
  static readonly type = new ElementType( "computation--form" );
  static readonly result = new ElementType( "computation--result" );
  static readonly functionName = new ElementAttribute( "function-name" );

  private static functions = new Map<string,( e:Element ) => any >();

  static addFunction( name:string, computationFunction:( e:Element ) => any )
  {
    ComputationForm.functions.set( name, computationFunction );
  }

  static applyOnDocument()
  {
    ComputationForm.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    let functionName = ComputationForm.functionName.from( e );
    let cb = ComputationForm.functions.get( functionName );

    console.log( "COMPUTE", functionName,  cb, ComputationForm.functions );


    let selects  = ElementType.select.queryAll( e );
    let inputs   = ElementType.input.queryAll( e );
    let results  = ComputationForm.result.queryAll( e );
    

    let compute = ()=>
    {
      let result:any = 0; 
      
      try 
      {
        result = cb( e );

        if ( isPrimitive( result ) )
        { 
          results[ 0 ].innerHTML = result + "";
        }
        else
        {
          for ( let it in result )
          {
            if ( ! result.hasOwnProperty( it ) )
            {
              continue;
            }

            let classFlag = new ClassFlag( it );

            results.forEach( 
              r =>
              {
                if ( ! classFlag.in( r ) )
                {
                  return;
                }

                r.innerHTML = result[ it ] + "";
              }
            );
            
          }      
        
        }

        
      }
      catch ( ex )
      {
        ComputationForm.result.query( e ).innerHTML = "Error computing result..." + ex;
      }

    };

    compute();

    selects.forEach( e => OnChange.add( e, compute ) );
    inputs.forEach( e => OnChange.add( e, compute ) );
  }


}